var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Base from "../../Base.js";
var StoreSum_default = (Target) => {
  var _a;
  return _a = class extends (Target || Base) {
    /**
     * Returns sum calculated by adding value of specified field for specified records. Defaults to using all locally
     * available records in store
     * @param {String} field Field to summarize by
     * @param {Core.data.Model[]} [records] Records to summarize, uses all records if unspecified.
     * @returns {Number}
     * @category Sum
     */
    sum(field, records = this.storage.values) {
      if (!records) {
        return 0;
      }
      return records.reduce((sum, record) => {
        if (record.isSpecialRow) {
          return sum;
        }
        const v = Number(record.getValue(field));
        return isNaN(v) ? sum : sum + v;
      }, 0);
    }
    /**
     * Returns min value for the specified field, can be used with Date or Number values. Defaults to look through all
     * locally available records in store
     * @param {String} field Field to find min value for
     * @param {Core.data.Model[]} [records] Records to process, uses all records if unspecified
     * @returns {Number|Date}
     * @category Sum
     */
    min(field, records = this.storage.values) {
      if (!(records == null ? void 0 : records.length)) {
        return 0;
      }
      return records.reduce((min, record) => {
        const fieldValue = record.getValue(field), type = typeof (fieldValue == null ? void 0 : fieldValue.valueOf());
        if (type === "number" && (fieldValue < min || min == null)) {
          min = fieldValue;
        }
        return min;
      }, records[0].getValue(field));
    }
    /**
     * Returns max value for the specified field, can be used with Date or Number values. Defaults to look through all
     * locally available records in store
     * @param {String} field Field to find max value for
     * @param {Core.data.Model[]} [records] Records to process, uses all records if unspecified
     * @returns {Number|Date}
     * @category Sum
     */
    max(field, records = this.storage.values) {
      if (!(records == null ? void 0 : records.length)) {
        return 0;
      }
      return records.reduce((max, record) => {
        const fieldValue = record.getValue(field), type = typeof (fieldValue == null ? void 0 : fieldValue.valueOf());
        if (type === "number" && (fieldValue > max || max == null)) {
          max = fieldValue;
        }
        return max;
      }, records[0].getValue(field));
    }
    /**
     * Returns the average value for the specified field. Defaults to look through all locally available records in
     * store
     * @param {String} field Field to calculate average value for
     * @param {Core.data.Model[]} [records] Records to process, uses all records if unspecified
     * @returns {Number}
     * @category Sum
     */
    average(field, records = this.storage.values) {
      if (!(records == null ? void 0 : records.length)) {
        return 0;
      }
      let count = 0;
      const sum = records.reduce((sum2, record) => {
        if (record.isSpecialRow) {
          return sum2;
        }
        const v = parseFloat(record.getValue(field));
        if (!isNaN(v)) {
          count++;
          return sum2 + v;
        } else {
          return sum2;
        }
      }, 0);
      return count > 0 ? sum / count : 0;
    }
    /**
     * Returns sum by adding value of specified field for records in the group with the specified groupValue.
     * @param {*} groupValue The group to summarize
     * @param {String} field Field to summarize by
     * @returns {Number} Sum or null if store not grouped
     * @category Sum
     * @non-lazy-load
     */
    groupSum(groupValue, field) {
      return this.sum(field, this.getGroupRecords(groupValue));
    }
  }, __publicField(_a, "$name", "StoreSum"), _a;
};
export {
  StoreSum_default as default
};
